import type { StateCreator } from "../store";
import type { AppStore } from "../index";
import { getPlatformStorageItem, setPlatformStorageItem } from "@/data/storage/platform_storage";

export interface CreditHistoryEntry {
  id: string;
  debit_account_id: string;
  credit_account_id: string;
  amount: string;
  pending_id: string;
  user_data_128: string;
  user_data_64: string;
  user_data_32: string;
  timeout: string;
  ledger: string;
  code: string;
  flags: string;
  timestamp: string;
}

export interface IapProduct {
  id: string;
  platform?: string;
  alias: string;
}

export interface CreditSlice {
  // State
  creditHistoryOnMonth: CreditHistoryEntry[];
  balance: number;
  iap: IapProduct[];

  // Actions
  setCreditHistoryOnMonth: (history: CreditHistoryEntry[]) => void;
  addCreditHistoryEntry: (entry: CreditHistoryEntry) => void;
  setBalance: (balance: number) => void;
  setIap: (iap: IapProduct[]) => void;
  clearCreditHistory: () => void;
}

export const createCreditSlice: StateCreator<AppStore, unknown, unknown, CreditSlice> = (set) => ({
  // Initial state - load balance from localStorage
  creditHistoryOnMonth: [],
  balance: Number(getPlatformStorageItem("balance")) || 0,
  iap: [],

  // Actions
  setCreditHistoryOnMonth: (history) =>
    set((state) => {
      state.creditHistoryOnMonth = history;
    }),

  addCreditHistoryEntry: (entry) =>
    set((state) => {
      state.creditHistoryOnMonth.push(entry);
    }),

  setBalance: (balance) =>
    set((state) => {
      state.balance = balance;
      // Persist to localStorage
      setPlatformStorageItem("balance", String(balance));
    }),

  setIap: (iap) =>
    set((state) => {
      state.iap = iap;
    }),

  clearCreditHistory: () =>
    set((state) => {
      state.creditHistoryOnMonth = [];
    }),
});
